/**
 * 产品分解模块 JavaScript
 * 将此文件保存到themes/your-theme/assets/目录下
 */

// 确保DOM完全加载后再执行代码
document.addEventListener('DOMContentLoaded', function() {
    // 初始化模块
    initProductBreakdown475();
});

/**
 * 初始化产品分解模块
 */
function initProductBreakdown475() {
    // 初始化事件监听器
    setupEventListeners931();
}

/**
 * 设置事件监听器
 */
function setupEventListeners931() {
    // 如果点击模态窗口以外的区域，关闭模态窗口
    const modalOverlay724 = document.getElementById('modalOverlay724');
    if (modalOverlay724) {
        modalOverlay724.addEventListener('click', function(e) {
            if (e.target === modalOverlay724) {
                closeModal632();
            }
        });
    }
}

/**
 * 打开模态窗口
 * @param {string} type - 模态窗口类型：'base' 或 'technique'
 */
function openModal284(type) {
    document.getElementById('modalOverlay724').classList.add('active');
    
    if (type === 'base') {
        document.getElementById('baseModal845').classList.add('active');
    } else if (type === 'technique') {
        document.getElementById('techniqueModal392').classList.add('active');
    }
    
    // 防止背景滚动
    document.body.style.overflow = 'hidden';
}

/**
 * 关闭模态窗口
 */
function closeModal632() {
    document.getElementById('modalOverlay724').classList.remove('active');
    document.getElementById('baseModal845').classList.remove('active');
    document.getElementById('techniqueModal392').classList.remove('active');
    
    // 恢复背景滚动
    document.body.style.overflow = '';
}

/**
 * 切换标签内容
 * @param {string} tabId - 需要显示的标签内容ID
 */
function showTab519(tabId) {
    // 获取当前模态窗口
    const modal = document.getElementById(tabId).closest('.modal');
    // 获取所有标签内容
    const tabContents = modal.querySelectorAll('.modal-tab-content');
    
    // 隐藏所有标签内容
    tabContents.forEach(tab => {
        tab.classList.remove('active');
    });
    
    // 显示选中的标签内容
    document.getElementById(tabId).classList.add('active');
    
    // 更新标签按钮样式
    const tabButtons = modal.querySelectorAll('.modal-tab');
    tabButtons.forEach(button => {
        button.classList.remove('active');
    });
    
    // 找到并激活点击的按钮
    Array.from(tabButtons).find(button => 
        button.getAttribute('onclick').includes(tabId)
    ).classList.add('active');
}

/**
 * 切换可展开部分
 * @param {string} id - 可展开内容的ID
 */
function toggleExpandable703(id) {
    const content = document.getElementById(id);
    const icon = document.getElementById(id + 'Icon');
    
    if (content.classList.contains('expanded')) {
        content.classList.remove('expanded');
        icon.classList.remove('expanded');
    } else {
        content.classList.add('expanded');
        icon.classList.add('expanded');
        
        // 设置内容高度
        content.style.height = content.scrollHeight + 'px';
    }
}

/**
 * 选择选项
 * @param {HTMLElement} element - 被点击的选项元素
 * @param {string} type - 选项类型：'base' 或 'tech'
 */
function selectOption846(element, type) {
    // 移除同类选项的活动状态
    const parent = element.parentElement;
    const options = parent.querySelectorAll('.option-card');
    options.forEach(option => {
        option.classList.remove('active');
    });
    
    // 为选中选项添加活动状态
    element.classList.add('active');
    
    // 获取选项名称和图片
    const optionName = element.querySelector('.option-name').textContent;
    const optionImage = element.querySelector('.option-image img').src;
    const optionDetail = element.getAttribute('data-base-detail') || element.getAttribute('data-technique-detail') || '';
    
    // 根据类型更新公式项
    if (type === 'base') {
        // 更新基础材料公式项
        const baseFormulaItem = document.querySelector('.formula-equation .formula-item:first-child');
        if (baseFormulaItem) {
            baseFormulaItem.querySelector('.formula-name').textContent = optionName;
            baseFormulaItem.querySelector('.formula-icon img').src = optionImage;
            baseFormulaItem.querySelector('.formula-detail').textContent = optionDetail;
            
            // 更新模态窗口图片
            const baseModalImage = document.getElementById('baseModalImage');
            if (baseModalImage) {
                baseModalImage.src = optionImage;
            }
        }
    } else if (type === 'tech') {
        // 更新工艺公式项
        const techFormulaItem = document.querySelector('.formula-equation .formula-item:last-child');
        if (techFormulaItem) {
            techFormulaItem.querySelector('.formula-name').textContent = optionName.includes("PRINT") ? "PRINTING" : "TECHNIQUE";
            techFormulaItem.querySelector('.formula-icon img').src = optionImage;
            techFormulaItem.querySelector('.formula-detail').textContent = optionDetail;
            
            // 更新模态窗口图片
            const techniqueModalImage = document.getElementById('techniqueModalImage');
            if (techniqueModalImage) {
                techniqueModalImage.src = optionImage;
            }
        }
    }
    
    // 更新产品预览图片
    updateProductPreview375();
}

/**
 * 更新产品预览图片
 * 在实际实现中，这个函数会根据选择的基础材料和工艺组合更新产品预览图片
 */
function updateProductPreview375() {
    // 实际应用中，这里会使用Ajax请求获取组合后的产品图片
    // 或者根据预先定义的规则更新预览图片
    console.log("Product preview would update here");
    
    // 示例实现：
    // 获取当前选中的基础材料和工艺
    const activeBase = document.querySelector('.options-grid:first-of-type .option-card.active');
    const activeTechnique = document.querySelector('.options-grid:last-of-type .option-card.active');
    
    if (activeBase && activeTechnique) {
        // 这里可以根据选择的选项组合来更新产品预览图片
        // 例如，可以发送Ajax请求到服务器，获取组合后的产品图片
        
        // 或者使用预先定义的规则，例如：
        // const baseId = activeBase.getAttribute('data-base-id');
        // const techniqueId = activeTechnique.getAttribute('data-technique-id');
        // const previewImage = `${baseId}-${techniqueId}.jpg`;
        // document.querySelector('.product-preview img').src = previewImage;
    }
} 